import React, { Component } from 'react';
import { Form, Input, FormGroup, Label } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { checkEmailCall } from '../../../../../../Redux/Actions/CommonActions';
import  CircularProgress  from '@material-ui/core/CircularProgress';

import _ from 'lodash';
import { auth } from '../../../../../../services';


class PortalUserForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email:'',
			userID:'',
			membershipId:0,
			MembershipPackageId:0,
			MailingStateId:44,
			memberSequenceNum:1,
			loading: false
		};
		this.delayedCallback = _.debounce(this.checkEmailCall, 2000);
        this.onEmailChange = this.onEmailChange.bind(this);
	}
	componentDidMount() {
		const membershipId =this.props.accountDetails.selectedMember.membershipId;
		this.setState({
			membershipId : membershipId
		});

		if (this.props.onRef) {
			this.props.onRef(this);
		}
	}

	reset() {
		this.setState({
			email: ''
		})
	}

	checkEmailCall() {
		if (this.state.email !== '') {
			this.props.checkEmailCall(this.state.email);
		}
		this.setState({
			loading:false
		})
  }

	onEmailChange = (event) => {
		var userId = '';
		if (auth.isAuthenticated()) {
			 userId = auth.getAuthUserId()
		}
		this.setState(
			{
				email: event.target.value,
				userID: userId
			},
			() => {
				this.setState({
					loading:true
				})
				this.delayedCallback();
				this.props.portalUserStateChange(this.state);
			}
			
		);
	};
	render() {
		return (
            <FormGroup style={{marginTop: '20px'}}>
                <Label htmlFor="exampleEmail" className="label-header">{this.props.emailLabel ? this.props.emailLabel : 'Email Lookup:'}</Label>
				
				<Input
					type="email"
					type={this.props.type ? this.props.type : 'email'}
					name="email"
					id="exampleEmail"
					value={this.state.email} 
					onChange={this.onEmailChange}
					placeholder="Please enter member email" />
					{this.state.loading == true ? <div style={{ verticalAlign: "middle", alignItems: 'center', textAlign: 'center' }}>
                        <CircularProgress style={{ display: 'block', margin: 'auto' }} /> <label>Loading...</label>
						</div> : ""
					}
				<p className={this.props.common.emailMessage == "User does not exist. Please create the user."?"error":""}>{this.props.common.emailMessage}</p>
				<p>{this.props.message}</p>
			</FormGroup>
			
		);
	}
}
function mapStateToProps(state) {
    return {
		common: state.common,
		membership: state.membership,
		accountDetails: state.accountDetails
    }
}

export default withRouter(connect(mapStateToProps, {checkEmailCall })(PortalUserForm));
